import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Cell} from './tableUtils';
import css from './usersTable.scss';
import Popup from '../popup/popup';
import DeleteUser from './deleteUser';
import SelectGroup from '../selectGroup/selectGroup';
import {Mutation} from 'react-apollo';
import {UPDATE_USER} from './queries';

class UpdateUser extends Component {
	state = {
		...this.props,
		group: this.props.group ? this.props.group.id : null,
	};
	static propTypes = {
		lastname: PropTypes.string.isRequired,
		firstname: PropTypes.string.isRequired,
		email: PropTypes.string.isRequired,
		group: PropTypes.object,
		enabled: PropTypes.bool = true,
	};
	setGroup = (groupId, callback) => {
		this.setState(
			_ => ({
				group: groupId,
			}),
			callback,
		);
	};
	isModified = _ => {
		for (let key in this.state) {
			if (key === 'group') {
				if (this.props.group) {
					if (this.state.group !== this.props.group.id) {
						return true;
					}
				} else if (this.state.group) {
					return true;
				}
			} else if (this.props[key] !== this.state[key]) {
				return true;
			}
		}
		return false;
	};
	updateState = (e, callback) => {
		let state = {};
		state[e.target.name] = e.target.value;
		if (e.target.type === 'checkbox') {
			state[e.target.name] = e.target.checked;
		}
		this.setState(_ => state, callback);
	};
	render() {
		const formClass = [css.form, this.isModified() ? 'modified' : ''];
		return (
			<Mutation mutation={UPDATE_USER} variables={this.state}>
				{(updateUser, {loading, error}) => (
					<form
						className={formClass
							.concat(loading ? 'loading' : '')
							.join(' ')}
						onSubmit={e => {
							e.preventDefault();
							updateUser();
						}}
					>
						<Row>
							<Cell type="deleteCol">
								<DeleteUser userId={this.props.id} />
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Nom"
									name="lastname"
									onChange={this.updateState}
									value={this.state.lastname}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Prénom"
									name="firstname"
									onChange={this.updateState}
									value={this.state.firstname}
								/>
							</Cell>
							<Cell type="email">
								<input
									type="email"
									placeholder="Email"
									name="email"
									onChange={this.updateState}
									value={this.state.email.toLowerCase()}
								/>
							</Cell>
							<Cell type="group" center>
								<SelectGroup
									group={this.props.group}
									onSelect={e => this.setGroup(e, updateUser)}
								/>
							</Cell>
							<Cell type="enable" center>
								<label>
									<input
										type="checkbox"
										name="enabled"
										onChange={e => {
											console.log(this.state.enabled)
											this.updateState(e, updateUser);
										}}
										checked={this.state.enabled}
										// checked={true}

									
									/>
									<div className={css.checkbox} />
								</label>
							</Cell>
							{error && (
								<Popup opened>
									{error.graphQLErrors[0]}
								</Popup>
							)}
						</Row>
						<input type="submit" hidden />
					</form>
				)}
			</Mutation>
		);
	}
}

export default UpdateUser;



// WEBPACK FOOTER //
// ./src/usersTable/updateUser.js